import { CheckIcon } from "@icons";
import { Tag } from "@design-system/Tag/Tag";
import type { TagSandboxState } from "./TagPlayground.lib";

const handleClick = () => {};
const handleRemove = () => {};

/**
 * Renders the sandbox Tag through size-narrowed branches so every combination
 * is a legal member of the prop union — no casts.
 */
export const TagSandboxPreview = ({
    size,
    color,
    isOutline,
    isNumeric,
    hasLeftIcon,
    isRemovable,
    isClickable,
    forcedState,
}: TagSandboxState & {
    /** Playground x-ray state, mirrored onto the live tag. */
    forcedState?: "hover";
}) => {
    const leftIcon = hasLeftIcon ? <CheckIcon /> : undefined;
    const onClick = isClickable ? handleClick : undefined;

    switch (size) {
        case "xs":
            return (
                <Tag
                    data-forced-state={forcedState}
                    size="xs"
                    numeric
                    color={color}
                    outline={isOutline}
                    onClick={onClick}
                >
                    1
                </Tag>
            );
        case "sm":
            if (isNumeric) {
                return (
                    <Tag
                        data-forced-state={forcedState}
                        size="sm"
                        numeric
                        color={color}
                        outline={isOutline}
                        onClick={onClick}
                    >
                        12
                    </Tag>
                );
            }

            return (
                <Tag
                    data-forced-state={forcedState}
                    size="sm"
                    color={color}
                    outline={isOutline}
                    leftIcon={leftIcon}
                    onClick={onClick}
                >
                    Tag
                </Tag>
            );
        case "md":
            if (isNumeric) {
                return (
                    <Tag
                        data-forced-state={forcedState}
                        size="md"
                        numeric
                        color={color}
                        outline={isOutline}
                        onClick={onClick}
                    >
                        12
                    </Tag>
                );
            }

            return (
                <Tag
                    data-forced-state={forcedState}
                    size="md"
                    color={color}
                    outline={isOutline}
                    leftIcon={leftIcon}
                    onClick={onClick}
                    onRemove={isRemovable ? handleRemove : undefined}
                >
                    Tag
                </Tag>
            );
        case "lg":
            if (isNumeric) {
                return (
                    <Tag
                        data-forced-state={forcedState}
                        size="lg"
                        numeric
                        outline={isOutline}
                        onClick={onClick}
                    >
                        12
                    </Tag>
                );
            }

            return (
                <Tag
                    data-forced-state={forcedState}
                    size="lg"
                    color={color === "accent" ? "accent" : "primary"}
                    outline={isOutline}
                    leftIcon={leftIcon}
                    onClick={onClick}
                    onRemove={isRemovable ? handleRemove : undefined}
                >
                    Tag
                </Tag>
            );
    }
};
